import { css as _css } from "@emotion/core";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import DomainGroupLogo from '@domain-group/fe-co-domain-group-logo';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AllhomesFooterToolbar } from './components/toolbar';
import { AllhomesFooterQuickLinks } from './components/quick-links';
import { CountryAcknowledgement } from './components/country-acknowledgement';
import allhomesFooterWrapper from './wrappers';
import * as styles from './allhomes-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesFooter = _ref => {
  var _ref$homepageLink = _ref.homepageLink,
    homepageLink = _ref$homepageLink === void 0 ? '/' : _ref$homepageLink,
    _ref$quickLinks = _ref.quickLinks,
    quickLinks = _ref$quickLinks === void 0 ? [] : _ref$quickLinks,
    _ref$copyrightInfo = _ref.copyrightInfo,
    copyrightInfo = _ref$copyrightInfo === void 0 ? {
      copyrightLink: '/ah/act/info/site-map/view',
      domainGroupLink: 'https://www.domain.com.au/group/'
    } : _ref$copyrightInfo;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showQuickLinks = _useState2[0],
    setShowQuickLinks = _useState2[1];
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    tablet = _useContext.tablet,
    desktop = _useContext.desktop;
  var toggleQuickLinks = () => setShowQuickLinks(old => !old);
  return ___EmotionJSX("div", {
    css: styles.footer
  }, ___EmotionJSX(AllhomesFooterToolbar, {
    toggleQuickLinks: toggleQuickLinks,
    isQuickLinksShown: showQuickLinks,
    homepageLink: homepageLink
  }), desktop && ___EmotionJSX(AllhomesFooterQuickLinks, {
    quickLinks: quickLinks
  }), (tablet || mobile) && ___EmotionJSX("div", {
    css: showQuickLinks ? styles.showQuickLinks : styles.hideQuickLinks
  }, ___EmotionJSX(AllhomesFooterQuickLinks, {
    quickLinks: quickLinks
  })), ___EmotionJSX("ul", {
    css: styles.copyright
  }, ___EmotionJSX("li", {
    css: /*#__PURE__*/_css([styles.copyrightItem, styles.copyrightItemLogo])
  }, ___EmotionJSX("a", {
    href: copyrightInfo.domainGroupLink,
    "aria-label": "Domain Group Logo"
  }, ___EmotionJSX(DomainGroupLogo, {
    primaryFill: "white",
    secondaryFill: "white"
  }))), ___EmotionJSX("li", {
    css: styles.copyrightItem
  }, ___EmotionJSX("a", {
    css: styles.copyrightLink,
    href: getAbsoluteUrl(copyrightInfo.copyrightLink)
  }, "\xA9 AllHomes Pty Ltd"))), ___EmotionJSX(CountryAcknowledgement, null));
};
export default allhomesFooterWrapper(AllhomesFooter);
export { AllhomesFooter as BaseAllhomesFooter };